app.factory('attachmentModel', ['$rootScope', '$location', 'baseModel', 'config', 'attachmentService',
    function($rootScope, $location, baseModel, config, attachmentService) {

        function AttachmentModel() {
            
            this.delete = function(id) {
                attachmentService.delete(id).then(
                    function (response) {
                        $rootScope.$broadcast(Event.ATTACHMENT.DELETE.SUCCESS, response);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ATTACHMENT.DELETE.ERROR, error);
                    }
                )
            };


        }

        return new AttachmentModel();
    }
]);
